import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const PromoactionsGiftCardFormLazy = loadable(
    () => import(/* webpackChunkName: "Promoactions" */ './PromoactionsGiftCardFormSuspense')
);

export const PromoactionsGiftCardFormAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <PromoactionsGiftCardFormLazy />
    </DelayedSuspense>
);
